export const TABLE_STOCK_NAME = 'stocks';
export const TABLE_ARRIVAL_NAME = 'arrivals';

export const COL_SEAT = 'seat';
export const COL_TIRE_SPEC = 'tireSpec';
export const COL_CAI = 'cai';
export const COL_ACTION = 'action';

export const MAX_VALUE = 999;
